import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LogDTO, LogType } from 'BaseDataTypes';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LogService {
  constructor(private http: HttpClient) {}

  /**
   * Gets all eventlogs with a specific EventPage from the database
   * @returns
   */
  getLogsByType(type: LogType): Observable<LogDTO[]> {
    const params = new HttpParams().set('type', type);
    return this.http.get<any>(`/api/Log/GetByType`, { params });
  }

  getLogHeaders(objectName: string) {
    if (!objectName) {
      objectName = "Navn";
    }
    let headers = ['Udført af',
      objectName,
      'Dato',
      'Handling',
      'Besked',
    ];
    return headers;
  }
}

